import React from "react";
import TeamCard from "./TeamCard";
import { TEAM_EMPTY_MANAGER, TEAM_EMPTY_OWNER, activeTeams } from "../../lib/teamManagement";

/**
 * Екипи — the team surface inside Потребители.
 *
 * An Owner sees every team of the organization and the controls to configure
 * them. A Manager sees ONLY the team they manage, with no controls at all: in
 * Phase 2D.3A a Manager reads the structure and changes nothing. A Sales user
 * never reaches this page.
 *
 * Team membership is NOT quotation authorization in this phase.
 */
export const TeamsPanel = ({
  teams,
  permissions,
  loading,
  error,
  busy,
  onCreate,
  onRename,
  onChangeManager,
  onAdd,
  onMove,
  onRemove,
  onArchive,
  onRestore,
  onDelete,
}) => {
  const canManage = permissions?.can_manage_teams === true;
  // A move needs a destination, so a team is movable-out of only while another
  // active team exists. Computed once for every card.
  const hasMoveTarget = activeTeams(teams).length > 1;

  if (loading) {
    return (
      <div className="qw-card" data-testid="teams-loading">
        Зареждане на екипите…
      </div>
    );
  }
  if (error) {
    return (
      <div className="qw-error" role="alert" data-testid="teams-error">
        {error}
      </div>
    );
  }

  return (
    <div data-testid="teams-panel">
      {canManage && (
        <button
          type="button"
          className="qw-btn primary"
          onClick={onCreate}
          disabled={busy}
          data-testid="team-create-button"
          style={{ marginBottom: 12 }}
        >
          Създай екип
        </button>
      )}

      {(teams || []).length === 0 ? (
        <div className="qw-card" data-testid="teams-empty">
          {canManage ? TEAM_EMPTY_OWNER : TEAM_EMPTY_MANAGER}
        </div>
      ) : (
        (teams || []).map((team) => (
          <TeamCard
            key={team.id}
            team={team}
            canManage={canManage}
            busy={busy}
            hasMoveTarget={hasMoveTarget}
            onRename={onRename}
            onChangeManager={onChangeManager}
            onAdd={onAdd}
            onMove={onMove}
            onRemove={onRemove}
            onArchive={onArchive}
            onRestore={onRestore}
            onDelete={onDelete}
          />
        ))
      )}
    </div>
  );
};

export default TeamsPanel;
